import React, {useEffect, useState} from 'react';
import numericFunction from "../../../utils/NumericFunction";
import {formatToPersianAddComma, formatToPersianAddCommaNegativeToParentheses} from "../../../utils/CommaSeparator";

const BalanceSheetPrint = (props) => {

  const format = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  let ROW_IN_PAGE = 40;

  const [componentData, setComponentData] = useState({})
  const [makeData, setMakeData] = useState([])

  useEffect(() => {
    const temp = {...props.data.data.mainData}
    // temp.data = [...temp.data, ...temp.data, ...temp.data, ...temp.data, ...temp.data, ...temp.data, ...temp.data]
    setComponentData(temp)
  }, [props.data])

  useEffect(() => {
    if (JSON.stringify(componentData) !== JSON.stringify({})) {
      let i = 0;
      let mainData = []
      while (i < componentData.data.length) {
        let temp = []
        for (let j = 0; j < ROW_IN_PAGE; j++) {
          temp.push(componentData.data[i])
          i = i + 1;
          if (i === componentData.data.length) {
            break;
          }
        }
        mainData.push(temp)
      }
      setMakeData(mainData)
    }
  }, [componentData])
  let TBed = 0
  let TBedRemaining = 0
  let TBes = 0
  let TBesRemaining = 0
  try {
    return (
      <div className="main-print-factor">
        {makeData.length > 0 && makeData.map((v, index) =>
          <>
            <div className="box-top-side-review-accounts">

              <div className="shop-name">
                <div className="name-side">
                  <h3>{componentData?.shopName}</h3>
                </div>
              </div>

              <div className="list-detail">
                <div className="inline-text">
                  <p>از تاریخ :</p>
                  <p>{numericFunction.e2p(componentData?.startDate)}</p>
                </div>

                <div className="inline-text">
                  <p>از سند :</p>
                  <p>{numericFunction.e2p(componentData?.firstId)}</p>
                </div>

                <div className="inline-text">
                  <p>تـاریـخ :</p>
                  <p>{new Date().toLocaleDateString("fa-ir", format)}</p>
                </div>

                <div className="inline-text">
                  <p>تا تاریخ :</p>
                  <p>{numericFunction.e2p(componentData?.endDate)}</p>
                </div>

                <div className="inline-text">
                  <p>تا سند :</p>
                  <p>{numericFunction.e2p(componentData?.lastId)}</p>
                </div>

                <div className="inline-text" style={{columnGap: '4px'}}>
                  <p>شماره صفحه :</p>
                  <p>{numericFunction.e2p(index + 1)}</p>
                  <p>از</p>
                  <p>{numericFunction.e2p(makeData.length)}</p>
                </div>
              </div>
            </div>

            <table className="solid-print-table">
              <thead>
              <tr>
                {componentData?.column.map((v, index) =>
                  <th key={"C" + index}>{v.title}</th>
                )}
              </tr>
              </thead>

              <tbody>
              {v?.map((q, index) => {
                  const accountCode = q.accountCode
                  const accountName = q.accountName
                  const bed = q.bed
                  const bes = q.bes
                  const bedRemaining = q.bedRemaining
                  const besRemaining = q.besRemaining
                  TBed += +q.bed
                  TBedRemaining += +q.bedRemaining
                  TBes += +q.bes
                  TBesRemaining += +q.besRemaining

                  return <tr key={"R" + index}>
                    <th>{numericFunction.e2p(accountCode)}</th>
                    <th>{accountName}</th>
                    <th>{formatToPersianAddCommaNegativeToParentheses(bed)}</th>
                    <th>{formatToPersianAddCommaNegativeToParentheses(bes)}</th>
                    <th>{formatToPersianAddCommaNegativeToParentheses(bedRemaining)}</th>
                    <th>{formatToPersianAddCommaNegativeToParentheses(besRemaining)}</th>
                  </tr>
                }
              )}
              </tbody>

              <tfoot>
              <tr>
                <th className="sum-caption">جمع صفحه</th>
                <th></th>
                <th>{formatToPersianAddCommaNegativeToParentheses(TBed)}</th>
                <th>{formatToPersianAddCommaNegativeToParentheses(TBes)}</th>
                <th>{formatToPersianAddCommaNegativeToParentheses(TBedRemaining)}</th>
                <th>{formatToPersianAddCommaNegativeToParentheses(TBesRemaining)}</th>
              </tr>
              </tfoot>
            </table>

            {makeData[makeData.length - 1] !== v && <div style={{pageBreakBefore: "always"}}></div>}
          </>)}
      </div>
    );
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }
};

export default BalanceSheetPrint;